import { render, staticRenderFns } from "./ConfigurationProvisionsCard.vue?vue&type=template&id=2a29ab66&"
import script from "./ConfigurationProvisionsCard.vue?vue&type=script&lang=js&"
export * from "./ConfigurationProvisionsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports